import { createApp } from './main'

const application = createApp()
const app = application.app
const router = application.router
const store = application.store

if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__)
}

router.onReady(function () {
  app.$mount('#app')
})
